<template lang='pug'>
  div
    Sidebar.sidebar
      transition-group.group-list(name="list-complete" mode="out-in" tag="ul")
        li.list-complete-item(key="groups")
          router-link.group-link(:to="{name: 'applicationAll'}")
            span {{$t('all_application')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from '@/components/mixins/sidebar/sidebar.vue'

export default {
  name: 'ApplicationIndex',
  components: {Sidebar},
}
</script>

<style scoped lang="scss">
.group-list {
  padding: 0;
  margin: 15px 0 0 9px;
  list-style: none;
  font-size: 14px;
  
  li {
    height: 35px;
    line-height: 35px;
    
    .group-link {
      display: block;
      width: 100%;
      padding: 0 0 0 12px;
      text-align: left;
      font-weight: 400;
      color: #6f6f6f;
      
      &.router-link-exact-active,
      &.router-link-active {
        color: $mainTheme;
        //background-color: #38d2b8;
        > span {
          font-weight: bolder;
        }
      }
      &:hover {
        // background-color: #16232d;
        color: #16191f;
      }
      > svg {
        vertical-align: middle;
      }
      > span {
        display: inline-block;
        padding: 1px 10px;
        vertical-align: top;
      }
    }
    
    &.active .group-link {
      background-color: #38d2b8;
      color: #fff;
    }
  }
}
</style>